var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.classes,attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"alt":_vm.alt}})
}]

export { render, staticRenderFns }